import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyledModal, StyledBody, TopSectionV2, PostButtonFeed, PostPopupTop } from '../PhotoAndPostFlow/styles';
import { withTranslation } from 'react-i18next';
import { AdminCloseIcon, CloseIconSmall } from '../../utils/icons';
import { toast } from "react-toastify";
import { ImageUrl } from '../../utils/constants';
import { fetchApi, getInitials } from "../../utils/methods";
import { TextAreaWrapperSearchPopup, SelectedUser, SelectedUserWrapper, PopupTitle } from './styles';
import { UserInitialsMain, UserDropdownContainer, ProfilePicture, DropDownStyledImage, ListDropdown, UserContainer} from '../SocialFeedsV2/styles'
import { Searchuserforchallengeinvite, Listremoveinviteduser, ModifyEventParticipants, SearchuserforEventInvite, SearchUserForEventRemove } from "../../redux/constants/apiConstants";
import Image from '../Image';
import { addRemoveUsers, getEventDetailsById } from '../../redux/actions';
import DeletePopup from '../DeletePostPopup/deletePopupBranding'

const AddUser = ({ showModal, onClose, challengeId, addRemoveUsers, user, type, challengeType, companyInfo, module, EventDetailsById, getEventAttendees }) => {
  const [selectedUsersData, setSelectedUsersData] = useState([]);
  const [searchUser, setSearchUser] = useState('');
  const [usersData, setUsersData] = useState([]);
  const [addRemoveUser, setAddRemoveUser] = useState([]);
  const inputRef = useRef(null);
  const [inputOffsetTop, setInputOffsetTop] = useState("0px");
  const [showRemovePopup, hideRemovePopup] = useState(false);

  useEffect(() => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      // Adjust offset if needed
      const offsetTop = rect.top + rect.height-120;
      setInputOffsetTop(`${offsetTop}px`);
      window.console.log("inputOffsetTop",inputOffsetTop)
    }
  }, [selectedUsersData, searchUser]);

  const postSearchUser = async (text) => {
    try {
      const postData = {
        "challenge_id" : challengeId,
        "search_name":text,
        "page_no": 1,
        "limit": 10
      }; 
      const res = await fetchApi(
        Searchuserforchallengeinvite,
        "POST",
        postData,
        {},
      );
      if (res?.data?.message) {
        toast.error(res?.data?.message)
      }
      
      setUsersData(res?.data?.list_data)
    } catch (error) {
      toast.error(error.message);
    }
  };

  const searchEventUser = async (text) => {
    const companyid=user?.company_id?user?.company_id:companyInfo?.id;
    try {
      const postData = {
        "event_id" : challengeId,
        "search_name":text,
        "page_no": 1,
        "limit": 10,
        company_id:companyid
      }; 
      const res = await fetchApi(
        SearchuserforEventInvite,
        "POST",
        postData,
        {},
      );
      if (res?.data?.message) {
        toast.error(res?.data?.message)
      }
      setUsersData(res?.data?.list_data)
    } catch (error) {
      toast.error(error.message);
    }
  };

  const searchRemoveEventUser = async (text) => {
    const companyid=user?.company_id?user?.company_id:companyInfo?.id;
    try {
      const postData = {
        "event_id" : challengeId,
        "search_name":text,
        "page_no": 1,
        "limit": 10,
        company_id:companyid
      }; 
      const res = await fetchApi(
        SearchUserForEventRemove,
        "POST",
        postData,
        {},
      );
      if (res?.data?.message) {
        toast.error(res?.data?.message)
      }
      setUsersData(res?.data?.list_data)
    } catch (error) {
      toast.error(error.message);
    }
  };

  const postRemoveSearchUser = async (text) => {
    try {
      const postData = {
        "challenge_id" : challengeId,
        "search_name":text,
        "page_no": 1,
        "limit": 10
      }; 
      const res = await fetchApi(
        Listremoveinviteduser,
        "POST",
        postData,
        {},
      );
      if (res?.data?.message) {
        toast.error(res?.data?.message)
      }
      setUsersData(res?.data?.list_data)
    } catch (error) {
      toast.error(error.message);
    }
  };

  // const submitAddRemoveUsers = () => {
  //   const postData = {
  //     "type": challengeType==="team"?"team": "user",
  //     "action": type==="Add"?"add":"remove",
  //     "ids": addRemoveUser
  //   }; 
  //   module === 'event' ? postData["event_id"] = challengeId : postData["challenge_id"] = challengeId,
  //   onClosePopup();
  //   hideRemovePopup(false)
  //   const companyid=user?.company_id ? user?.company_id:companyInfo?.id;
  //   module === 'event'? EventAddRemoveUser(postData, companyid) : addRemoveUsers(postData, companyid)
  // };

  const submitAddRemoveUsers = () => {
    const postData = {
      type: challengeType === "team" ? "team" : "user",
      action: type === "Add" ? "add" : "remove",
      ids: addRemoveUser,
    };
  
    // ✅ Clear and explicit assignment
    if (module === "event") {
      postData["event_id"] = challengeId;
    } else {
      postData["challenge_id"] = challengeId;
    }
  
    // ✅ These are separate calls, not comma-chained
    onClosePopup();
    hideRemovePopup(false);
  
    const companyid = user?.company_id ? user?.company_id : companyInfo?.id;
  
    if (module === "event") {
      EventAddRemoveUser(postData, companyid);
    } else {
      addRemoveUsers(postData, companyid);
    }
  };

  const EventAddRemoveUser = async(postData, companyid)=>{

    const res = await fetchApi(ModifyEventParticipants + '/' + companyid, "POST", postData);
    if(res.status === 'success'){
      toast.success(res?.data[0]);
      EventDetailsById(challengeId);
      getEventAttendees(challengeId)
    }else if(res?.data?.message){
      toast.error(res?.data?.message)

    }

  }

  // const handleChange = (e) => {
  //   const input = e.target.value;
  //   setSearchUser(input)
  //   if(type==="Add"){ 
  //     postSearchUser(input)
  //   }else{
  //     postRemoveSearchUser(input)
  //   }
  // };

  const handleChange = (e) => {
    setSearchUser(e.target.value);
  };

  // useEffect(() => {
  //   const trimmedInput = searchUser.trim();
  
  //   // Don't trigger if input is empty or max users already selected
  //   if (!trimmedInput || selectedUsersData.length === 10) return;
  
  //   const delayDebounceFn = window.setTimeout(() => {
  //     if (type === "Add") {
  //       module === 'event' ? searchEventUser(trimmedInput) : postSearchUser(trimmedInput);
  //     } else {
  //       module === 'event' ?  searchRemoveEventUser(trimmedInput) : postRemoveSearchUser(trimmedInput);
  //     }
  //   }, 400); // 400ms debounce time
  
  //   // Cleanup previous timer on input change
  //   return () => window.clearTimeout(delayDebounceFn);
  // }, [searchUser, type, selectedUsersData.length]);
  


  useEffect(() => {
    const trimmedInput = searchUser.trim();
    let delayDebounceFn;
  
    if (trimmedInput && selectedUsersData.length !== 10) {
      delayDebounceFn = window.setTimeout(() => {
        if (type === "Add") {
          module === 'event'
            ? searchEventUser(trimmedInput)
            : postSearchUser(trimmedInput);
        } else {
          module === 'event'
            ? searchRemoveEventUser(trimmedInput)
            : postRemoveSearchUser(trimmedInput);
        }
      }, 400);    // 400ms debounce time
    }
  
    return () => {
      if (delayDebounceFn) window.clearTimeout(delayDebounceFn);
    };
  }, [searchUser, type, selectedUsersData.length]);
  

  const selectUserFromPopup = (data) => {
    const userId = data.uid || data.id; // fallback to id if uid is not available
  
    const alreadySelected = selectedUsersData.some(
      (user) => (user.uid || user.id) === userId
    );
  
    if (!alreadySelected) {
      setSelectedUsersData([...selectedUsersData, data]);
      setAddRemoveUser([...addRemoveUser, userId]);
    }
  
    setSearchUser('');
  };
  
  

  const containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png")||!str;
    return defaultPngFound;
  }

  const removeSingleUser = (data) => {
    const userId = data.uid || data.id;
  
    const isUserPresent = selectedUsersData.some(
      (user) => (user.uid || user.id) === userId
    );
  
    if (isUserPresent) {
      const updatedUsers = selectedUsersData.filter(
        (user) => (user.uid || user.id) !== userId
      );
  
      setSelectedUsersData(updatedUsers);
  
      // Update addRemoveUser accordingly
      const updatedAddRemoveUser = addRemoveUser.filter((id) => id !== userId);
      setAddRemoveUser(updatedAddRemoveUser);
    }
  };
  
  
  const onClosePopup =()=>{
    onClose()
    setAddRemoveUser([])
    setUsersData([])
    setSelectedUsersData([])
    setSearchUser('')
    hideRemovePopup(false)
  }

  const onClosehideRemovePopup = () => {
    hideRemovePopup(false)
  }

  const Heading = (
    <>
      {`Are you sure you want to remove this ${challengeType==="team" ? "team" : 'participant'} from the
      ${module ? module : 'challenge'}?`}
    </>
  );

  // const teamHeading = (
  //   <>
  //     Are you sure you want to remove this team from the<br />
  //     challenge?
  //   </>
  // );
  
  // const userHeading = (
  //   <>
  //     Are you sure you want to remove this participant<br />
  //     from the challenge?
  //   </>
  // );
  
  const subHeading = (
    <>
      This action cannot be undone, and all their progress<br />
      and data will be permanently removed.
    </>
  );


  return (
    <div>
      {showRemovePopup?<DeletePopup
        showModal={showRemovePopup}
        onClose={onClosehideRemovePopup}
        deleteConsumer={submitAddRemoveUsers}
        title={challengeType==="team"?`${type} Team`:`${type} User`}
        heading= {Heading}
        subHeading={subHeading}
        isChallengePopup={1}
        type={challengeType==="team"?"team":"Participant"}
      />:
        <StyledModal show={showModal} width="600px" background="#F8F8F8">
          <PostPopupTop>
            <div className='heading'>{challengeType?`${type} Team`: `${type} User`}</div>
            <div className='closeIcon' onClick={() => onClosePopup()}>{AdminCloseIcon()}</div>
          </PostPopupTop>
          <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "0" }} />
          <StyledBody>
            {challengeType==="team"?<PopupTitle>{type==="Add"? "Which team would you like to add?":"Which team would you like to remove?"} </PopupTitle>:
              <PopupTitle>{type==="Add"? "Who would you like to add?":"Who would you like to remove?"} </PopupTitle>}
            <TopSectionV2 background maxHeight="320px" margin="16px 0" isPadding={ usersData?.length>0 ? "0": "10px"}>
              <TextAreaWrapperSearchPopup >
                <SelectedUserWrapper width={selectedUsersData?.length > 0?"auto":"100%"}>
                  { selectedUsersData?.length > 0  ? selectedUsersData.map((data, index) => (
                    <SelectedUser key={index}>
                      {challengeType==="team"?<div className="profile">
                        {!containsDefaultPng(data?.logo)?
                          <img src={`${ImageUrl}/${data?.logo}`}/>:
                          <UserInitialsMain size="12px">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                      </div>:<div className="profile">
                        {!containsDefaultPng(data?.profile_image)?
                          <img src={`${ImageUrl}/${data?.profile_image}`}/>:
                          <UserInitialsMain size="12px">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                      </div>}
                      <div className="username">{data?.name}</div>
                      <div className='closeicon' onClick={() => removeSingleUser(data)}>
                        {CloseIconSmall()}
                      </div>
                    </SelectedUser>
                  )) : null
                  }
                  <textarea
                    ref={inputRef}
                    id="inlineAutoTextarea"
                    value={searchUser}
                    onChange={selectedUsersData?.length === 10?null: handleChange}
                    placeholder=""
                  />
                </SelectedUserWrapper>
              </TextAreaWrapperSearchPopup>
              <UserContainer
                showSuggestor={searchUser?.length>0}
                // top={usersData?.length===0&&selectedUsersData?.length > 0?"80px":inputOffsetTop}
                top={'46%'}
                width="350px !important"
              >
                { usersData?.length>0 ? 
                  // Dynamically choose the data to map based on location.pathname
                  ( usersData && usersData?.map((user, index) => (
                    <UserDropdownContainer
                      key={index}
                      index={index}
                      onClick={() => selectUserFromPopup(user)}
                    >
                      <ProfilePicture>
                        <DropDownStyledImage width="100%" left height="40px" style={{ padding: "5px" }}>
                          {challengeType==="team"?<div className="middle" style={{ display: "inline-block" }}>
                            {!containsDefaultPng(user.logo) ? (
                              <Image
                                style={{ width: "30px", display: "inline-block" }}
                                image={user?.logo?user?.logo:user.profile_image}
                                alt={user.name}
                              />
                            ) : (
                              <UserInitialsMain style={{ width: "40px", height: "40px", margin: "5px 10px" }}>
                                {`${getInitials(user.name)}`}
                              </UserInitialsMain>
                            )}
                          </div>:
                            <div className="middle" style={{ display: "inline-block" }}>
                              {!containsDefaultPng(user.profile_image) ? (
                                <Image
                                  style={{ width: "30px", display: "inline-block" }}
                                  image={user?.logo?user?.logo:user.profile_image}
                                  alt={user.name}
                                />
                              ) : (
                                <UserInitialsMain style={{ width: "40px", height: "40px", margin: "5px 10px" }}>
                                  {`${getInitials(user.name)}`}
                                </UserInitialsMain>
                              )}
                            </div>}
                          <ListDropdown index={index}>
                            <span style={{ marginLeft: "10px" }}>{user.name}</span>
                          </ListDropdown>
                        </DropDownStyledImage>
                      </ProfilePicture>
                    </UserDropdownContainer>
                  ))
                  ) : 
                  <span className='no-data'>No Data Found</span>
                }
              </UserContainer>
              <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "16px 0 16px 0" }} />
              <PostButtonFeed disable={selectedUsersData?.length === 0} gap="16px" onClick={selectedUsersData?.length === 0?null:type==="Add"?()=>submitAddRemoveUsers():()=>hideRemovePopup(true)}>
                <div className='button'>
                  {challengeType?type==="Add"?`${type} Team`:type:type==="Add"?`${type} User`:type}
                </div>
              </PostButtonFeed>
            </TopSectionV2>
          </StyledBody>
        </StyledModal>}
    </div>
  );
};

AddUser.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  companyId: PropTypes.number.isRequired,
  user: PropTypes.object,
  t: PropTypes.func,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  challengeId: PropTypes.number,
  addRemoveUsers: PropTypes.func,
  type: PropTypes.string,
  challengeType: PropTypes.string,
  companyInfo: PropTypes.object,
  module:PropTypes.string,
  EventDetailsById:PropTypes.func,
  getEventAttendees:PropTypes.func
};

const mapStateToProps = (state) => ({
  user: state.profileData.user
});

const mapDispatchToProps = (dispatch) => ({
  addRemoveUsers: (data, companyid) => dispatch(addRemoveUsers(data, companyid)),
  EventDetailsById: (id) => dispatch(getEventDetailsById(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddUser));
